export default "__VITE_ASSET__Dg15upzk__"